export default {"src":"/_next/static/media/Nomino.2afb5998.svg","height":80,"width":80};